import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PrizesAndPerksService {

  constructor(private http: HttpClient) { }

  getPrizesAndPerksList(): Observable<any>{
    const url = environment.apiURL + `api/prizes_and_perks/list`;
    return this.http.get(url);
  }

  getPrizesAndPerksStep(step: number): Observable<any>{
    const url = environment.apiURL + `api/prizes_and_perks/${step}`;
    return this.http.get(url);
  }

  deletePrizePerk(id: any): Observable<any> {
    const url = environment.apiURL + `api/prizes_and_perks/delete/${id}`;
    return this.http.delete(url, {responseType: 'text'});
  }

  updatePrizePerk(formData: FormData, updatedData: any, id: number): Observable<any> {
    const url = environment.apiURL + `api/prizes_and_perks/update/${id}`;
    console.log('inside update pricing data start', updatedData);

    let params = new HttpParams();
    params = params.append('title', updatedData.title);
    params = params.append('sub_title', updatedData.sub_title);
    params = params.append('step', updatedData.step.toString());
    params = params.append('type', updatedData.type);
    if (updatedData.description) {
      params = params.append('description', updatedData.description);
    }
    if (updatedData.sub_description) {
      params = params.append('sub_description', updatedData.sub_description);
    }

    console.log('Param:', params);
    return this.http.patch(url, formData, { params: params, responseType: 'text' });
  }

  addPrizePerk(formData: FormData, updatedData: any): Observable<any> {
    const url = environment.apiURL + `api/prizes_and_perks/create`;
    console.log('inside update pricing data start', updatedData);

    let params = new HttpParams();
    params = params.append('title', updatedData.title);
    params = params.append('sub_title', updatedData.sub_title);
    params = params.append('step', updatedData.step.toString());
    params = params.append('type', updatedData.type);
    if (updatedData.description) {
      params = params.append('description', updatedData.description);
    }
    if (updatedData.sub_description) {
      params = params.append('sub_description', updatedData.sub_description);
    }

    console.log('Param:', params);
    return this.http.post(url, formData, { params: params, responseType: 'text' });
  }
}
